// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2zvQx","title":"ClientReferral_title__2rRXg","itemText":"ClientReferral_itemText__Y3ZOX"};